// The wire request limit rules. The server holds the same code and range in WireRequestAccessEvaluator - change
// them there and here together.
//
// The permission code is what grants wire ACCESS, which is separate from the limit: a user keeps a stored limit
// after their roles stop granting wire, so anything showing the limit has to ask about access too.
export const WIRE_REQUEST_PERMISSION_CODE = 'deposit.create.wire'

// The minimum is the smallest amount the payment screen accepts for any request, so a smaller limit could never allow
// one. The maximum is also the payment amount field's ceiling when the user has no limit.
export const MINIMUM_WIRE_REQUEST_LIMIT = 2
export const MAXIMUM_WIRE_REQUEST_LIMIT = 99999999.99

// vee-validate rules for a limit field (the user's limit, the subscriber's default): whole cents within the range.
export const WIRE_REQUEST_LIMIT_RULES = {
  decimal: 2,
  min_value: MINIMUM_WIRE_REQUEST_LIMIT,
  max_value: MAXIMUM_WIRE_REQUEST_LIMIT
}

// The money field hands back a number, a string or blank. Blank becomes null, a numeric string a number, and anything
// else is returned as it is. The field's decimal rule stops that first, the save refuses what gets past it
// (isReadableWireRequestLimit), and the server refuses an out-of-range number through its validators.
export function normaliseWireRequestLimit (value) {
  if (value === null || value === undefined || value === '') return null
  const limit = Number(value)
  return isFinite(limit) ? limit : value
}

// Whether a normalised limit can be sent: blank or a number. Checked before saving so the user gets a plain message:
// sent, anything else fails deserialisation and the server answers with a model binding 500.
export function isReadableWireRequestLimit (limit) {
  return limit === null || (typeof limit === 'number' && isFinite(limit))
}
